const gamePlayReducer = (state=false,action)=>{
    switch(action.type){
        case "GAMEOVER":
            return false;
        case "GAMEON":
            return true;
        default:
            return state;
    }
}

export default gamePlayReducer;